import { Directive, ElementRef, HostListener, Input, inject } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { IMAGE_UNAVAILABLE_KEY, applyImageFallback } from './image-fallback.directive';

/** Thumbnail retry: on error swap to `imageSrc` (or one of its comma-separated variants), then to the placeholder. */
@Directive({
  selector: '[ogImageSource]',
})
export class ImageSourceDirective {
  @Input() imageSrc: string;
  @Input() multipleImageIndex: number;

  private readonly element = inject<ElementRef<HTMLImageElement>>(ElementRef);
  private readonly transloco = inject(TranslocoService);
  private loadImageTryCount = 0;

  @HostListener('error', ['$event'])
  onErrorLoadingImage(event: Event) {
    this.loadImageTryCount++;
    if (this.loadImageTryCount > 1 || !this.imageSrc) {
      applyImageFallback(this.element.nativeElement, this.transloco.translate(IMAGE_UNAVAILABLE_KEY));
      return;
    }
    if (this.multipleImageIndex) {
      const imagesArray = this.imageSrc.split(',');
      (event.target as HTMLEmbedElement).src = imagesArray[this.multipleImageIndex];
    } else {
      (event.target as HTMLEmbedElement).src = this.imageSrc;
    }
  }
}
